import { mapObject, constant, uniqueId } from 'underscore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { ContextualMenu, IconButton as FabricIconButton } from '@bingads-webui-react/fabric-control';
import { DirectionalHint } from '@fluentui/react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getContextualMenuIconButtonStyles } from './styles';

class ContextualMenuIconButton extends React.PureComponent {
  renderMenu = props => (<ContextualMenu {...props} />);

  render() {
    const {
      classes,
      iconName,
      'aria-label': ariaLabel,
      items,
      contextualMenuProps,
    } = this.props;

    const className = classNames(
      classes.iconButtonContainer,
      'contextual-menu-icon-button-container'
    );

    const menuProps = {
      items: items.reduce((memo, item) => memo.concat({
        key: uniqueId('custom-menu-'),
        ...item,
      }), []),
      shouldFocusOnMount: true,
      directionalHint: DirectionalHint.bottomLeftEdge,
      ...contextualMenuProps,
    };

    return (
      <div className={className} ref={this.buttonRef}>
        <FabricIconButton
          className={classNames(iconName, 'icon-button')}
          iconProps={{ iconName }}
          menuProps={menuProps}
          menuAs={this.renderMenu}
          onRenderMenuIcon={() => null}
          ariaLabel={ariaLabel}
        />
      </div>
    );
  }
}

ContextualMenuIconButton.propTypes = {
  /**
   * Define the classes for ContextualMenuIconButton container
   * ContextualMenuIconButton container name can be customized.
   * Default value is 'ContextualMenuIconButton'
   */
  classes: PropTypes.shape(mapObject(
    getContextualMenuIconButtonStyles({}, {}),
    constant(PropTypes.string.isRequired)
  )).isRequired,
  /**
   * The name of the icon to use from the icon font.
   */
  iconName: PropTypes.string.isRequired,
  /**
   * Items is a data array for menu list.
   */
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  /**
   * custom contextual menu props outside
   */
  contextualMenuProps: PropTypes.shape({}),
  /**
   * Aria label of IconButton.
   */
  'aria-label': PropTypes.string,
};

ContextualMenuIconButton.defaultProps = {
  'aria-label': '',
  contextualMenuProps: {},
};

export const StyledContextualMenuIconButton =
  withDefaultStyles(ContextualMenuIconButton, getContextualMenuIconButtonStyles);
